import React from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import SegmentExecutionPane from '../../../containers/segment/execution/Pane';
import SegmentExecutionSummaryGrid from '../../../containers/segment/execution/SummaryGrid';
import SegmentExecutionDetails from '../../../containers/segment/execution/Details';

const SegmentExecutionPaneContainer = ({ tenantId }) => {
  const navigate = useNavigate();
  const params = useParams();

  return (
    <SegmentExecutionPane params={params} navigate={navigate}>
      <SegmentExecutionSummaryGrid
        navigate={navigate}
        tenantId={tenantId}
        additionalStyle={{ padding: 15 }}
      />
      <SegmentExecutionDetails />
    </SegmentExecutionPane>
  );
};

export default SegmentExecutionPaneContainer;
